<template>
  <div class="container-detail" v-if="!isLoading">
    <div class="detail-about">
      <div class="detail-header-buttons">
        <div class="main-title">Подробнее о выборах</div>

        <div class="header-buttons-right">
          <v-btn
            @click="goToEdit"
            style="width: auto !important"
            class="button-action-blue"
          >
            Редактировать
          </v-btn>
        </div>
      </div>
      <div
        class="d-flex align-center main-container-info-box"
        style="margin: 0 24px 40px 0"
      >
        <v-switch
          v-model="showBlock"
          hide-details
          @change="showInApp"
          color="var(--app-green-1)"
        ></v-switch>
        <span>Отображать раздел</span>
      </div>

      <div class="detail-main">
        <div class="detail-main-first-container">
          <div class="first-container-box">
            <div class="container-box-title">Заголовок</div>
            <div class="container-box-text">
              {{ detailsBlock.title }}
            </div>
          </div>
          <div class="first-container-box">
            <div class="container-box-title">Подзаголовок</div>
            <div class="container-box-text">
              {{ detailsBlock.subtitle }}
            </div>
          </div>
          <div class="first-container-box">
            <div class="container-box-title">Текст блока</div>
            <div class="container-box-text">
              {{ detailsBlock.text }}
            </div>
          </div>
        </div>
        <div class="detail-main-second-container">
          <div class="second-container-box">
            <div class="container-box-title">Изображения</div>
            <div class="container-box-text">
              Нажмите на изображение, чтобы увидеть его в полном размере
            </div>
          </div>
          <div>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Формат</th>
                    <th class="text-left">Место отображенния</th>
                    <th class="text-left">Для смартфонов</th>
                    <th class="text-left">Для планшетов</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style="height: 60px">
                    <td class="text-left">Фото</td>
                    <td class="text-left">
                      Отображается в «Подробнее о выборах»
                    </td>
                    <td class="text-left">
                      <img
                        @click="openDialogImg(detailsBlock.imageMobile)"
                        v-if="detailsBlock.imageMobile"
                        class="table-img"
                        :src="detailsBlock.imageMobile"
                      />
                    </td>
                    <td class="text-left">
                      <img
                        @click="openDialogImg(detailsBlock.imageTablet)"
                        v-if="detailsBlock.imageTablet"
                        class="table-img"
                        :src="detailsBlock.imageTablet"
                      />
                    </td>
                  </tr>

                  <tr style="height: 60px">
                    <td class="text-left">Обложка</td>
                    <td class="text-left">Изображение на фоне раздела</td>
                    <td class="text-left">
                      <img
                        @click="openDialogImg(detailsBlock.coverMobile)"
                        v-if="detailsBlock.coverMobile"
                        class="table-img"
                        :src="detailsBlock.coverMobile"
                      />
                    </td>
                    <td class="text-left">
                      <img
                        @click="openDialogImg(detailsBlock.coverTablet)"
                        v-if="detailsBlock.coverTablet"
                        class="table-img"
                        :src="detailsBlock.coverTablet"
                      />
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <DialogImage v-model="dialogImg" :src="previewImage" />
            <v-divider></v-divider>
            <div class="info-block">
              <div class="info-block-title">Добавленная ссылка</div>

              <div class="info-block-text">
                <a
                  v-if="detailsBlock.url"
                  style="word-break: break-all"
                  target="_blank"
                  :href="detailsBlock.url"
                  >{{ detailsBlock.url }}</a
                >
                <span style="color: var(--app-dark-grey-1);" v-else>Добавленной ссылки пока нет</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="detail-stages">
      <div class="detail-main">
        <div class="detail-main-first-container">
          <div class="first-container-box">
            <div class="container-box-title">Этапы</div>
            <div class="container-box-text">
              Нажмите на изображение, чтобы увидеть его в полном размере
            </div>
          </div>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Номер</th>
                  <th class="text-left">Название</th>
                  <th class="text-left">Детализация</th>
                  <th class="text-left">Сроки</th>
                  <th class="text-left">Для смартфонов</th>
                  <th class="text-left">Для планшетов</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  style="height: 60px"
                  v-for="(item, index) in electionStages"
                  :key="index"
                >
                  <td class="text-left">{{ item.stage + 1 }}</td>
                  <td class="text-left">{{ item.name }}</td>
                  <td class="text-left">{{ item.detail }}</td>
                  <td class="text-left">{{ item.dates }}</td>
                  <td class="text-left">
                    <img
                      @click="openDialogImg(item.imageMobile)"
                      v-if="true"
                      class="table-img"
                      :src="item.imageMobile"
                    />
                  </td>
                  <td class="text-left">
                    <img
                      @click="openDialogImg(item.imageTablet)"
                      v-if="true"
                      class="table-img"
                      :src="item.imageTablet"
                    />
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    electionDetails: null,
    detailsBlock: null,
    electionStages: null,
    dialogImg: false,
    previewImage: null,
    hideNews: false,
    imageWidth: 0,
    dialogDelete: false,
    isLoading: true,
    showBlock: null,
  }),
  methods: {
    openDialogImg(src) {
      this.previewImage = src;
      this.dialogImg = true;
    },
    back() {
      this.$router.go(-1);
    },
    goToEdit() {
      this.$emit("goToEdit");
    },
    getFullName(item) {
      return `${item.user.lastName} ${item.user.firstName} ${item.user.middleName}`;
    },
    showInApp() {
      const documentsBody = {
        showBlock: this.showBlock,
      };
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV5 +
            "/ksa-election-blocks/election-details/visibility",
          documentsBody,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then(() => {
          this.$store.commit("errorSet", {
            key: true,
            text: "Статус успешно изменен",
            type: "success",
          });
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    getElectionDetails() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV5 +
            "/ksa-election-blocks/election-details",
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then((res) => {
          this.detailsBlock = res.data.detailsBlock;
          this.showBlock = res.data.detailsBlock.showBlock;
          this.electionStages = res.data.electionStages;
          this.isLoading = false;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
  },
  created() {
    this.getElectionDetails();
  },
};
</script>
<style lang="scss" scoped>
.container-detail {
  box-sizing: border-box;
  padding: 40px !important;

  .detail-header-buttons {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;

    .main-title {
      font-weight: 400;
      font-size: 28px;
      line-height: 100%;
    }

    .header-buttons-right {
      display: flex;
      align-items: center;
      gap: 18px;
    }
  }

  .detail-main {
    display: flex;
    justify-content: space-between;

    .detail-main-first-container {
      width: 40%;

      .first-container-box {
        margin-bottom: 40px;

        .container-box-title {
          font-weight: 600;
          font-size: 24px;
          line-height: 100%;
          margin-bottom: 12px;
        }

        .container-box-text {
          font-size: 18px;
          font-weight: 400;
        }

        .container-box-text-list {
          .container-box-text-list-item {
            display: flex;
            margin-bottom: 5px;

            .list-item-subtitle {
              font-size: 16px;
              font-weight: 600;
              color: #929292;
              width: 200px;
            }

            .list-item-text {
              font-size: 18px;
              font-weight: 400;
            }
          }
        }
      }
    }

    .detail-main-second-container {
      width: 56%;

      .table-img {
        cursor: pointer;
        height: 38px;
        object-fit: contain;
      }

      .second-container-box {
        width: 100%;
        margin-bottom: 40px;

        .container-box-title {
          font-size: 24px;
          font-weight: 600;
        }

        .container-box-text {
          font-size: 18px;
          font-weight: 400;
        }
      }
      .info-block {
        width: 100%;
        margin: 12px 0 0 0;

        .info-block-title {
          font-size: 24px;
          font-weight: 600;
          margin-bottom: 12px;
        }

        .info-block-text {
          font-size: 18px;
          font-weight: 400;
        }
      }
    }
  }
  .dialog-delete-custom {
    .delete-wrapper {
      .dialog-title-custom {
        .title-custom {
          font-weight: 500;
          font-size: 24px;
          line-height: 20px;
          color: var(--app-dark-blue-3);
        }
      }
    }
  }
  .detail-stages {
    .table-img {
      cursor: pointer;
      height: 38px;
      object-fit: contain;
    }
    .detail-main {
      width: 100%;
      display: flex;

      .detail-main-first-container {
        width: 100%;
        .first-container-box {
          margin-bottom: 40px;

          .container-box-title {
            font-weight: 600;
            font-size: 24px;
            line-height: 100%;
            margin-bottom: 12px;
          }

          .container-box-text {
            font-size: 18px;
            font-weight: 400;
          }

          .container-box-text-list {
            .container-box-text-list-item {
              display: flex;
              margin-bottom: 5px;

              .list-item-subtitle {
                font-size: 16px;
                font-weight: 600;
                color: #929292;
                width: 200px;
              }

              .list-item-text {
                font-size: 18px;
                font-weight: 400;
              }
            }
          }
        }
      }
    }
  }
}
</style>
